import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Toolbar from '../../../components/Admin/Superhosts/Toolbar';
// import Toolbar from 'components/Admin/Superhost/Toolbar';
import  {momentLocalizer} from 'react-big-calendar';
import moment from 'moment';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import { SuperhostList } from '../../../components/Admin/Superhosts/List/SuperhostList';

const {
	showDeleteSuperhostsConfirmationModal,
	getSuperhosts
} = actions;

class Superhosts extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.timer = true;
    this.state = {
      user_ids: [],
      page: props.page || 1,
      searchQuery: {
        // order: {},
        ...props.query
      },
      startDate: null,
      endDate: null
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.total_pages != this.props.total_pages)
      this.setState({
        page: 1
      })
  }

  componentWillMount = () => {
    this.updateUsersList();
  }

  deleteSuperhosts = () => {
    if(this.state.user_ids.length > 0)
      this.props.deleteSuperhosts(this.state.user_ids)
  }

  onChangePage = (page = 1) => {
    this.setState({
      page
    }, this.updateUsersList);
  }

  onOrderChange = (field = 'created_at', order = 'desc') => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        // [field]: order
      }
    }
    this.setState({
      searchQuery
    }, this.updateUsersList)
  }

  checkedUserIds = (user_id) => {
    var ids = _.assign(this.state.user_ids),
      index = this.state.user_ids.indexOf(user_id);

    if(index == -1) {
      ids.push(user_id)
    } else {
      ids.splice(index, 1)
    }
    this.setState({ user_ids: ids })
  }

  changeFilterQuery = (field, value) => {
    const query = {...this.state.searchQuery, ...{ [field]: value }};
    this.setState({searchQuery: query, page: 1 }, () => {
      if(this.timer){
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500)
    })
  }

  onDateRangeChange = (field, start, end) => {
    const query = {
      ...this.state.searchQuery,
      ...{ [`${field}_from`]: start,
        [`${field}_to`]: end
      }
    };
    this.setState({searchQuery: query, page: 1 }, () => {
      if(this.timer){
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500)
    })
  }

  updateUsersList = () => {
    const {
      page,
      searchQuery
    } = this.state;
    this.props.getSuperhosts(searchQuery, page);
  }

  render() {
    const {
      deleteSuperhosts
    } = this;
    const localizer = momentLocalizer(moment);

    return (
      <main className="site--width clearfix container_statistics">
        <Toolbar
          toolsProps={{
            deleteSuperhosts,
            count: this.props.count
          }}
        />
        <div className="admin_user_table admin_table">
          <SuperhostList
            onOrderChange={this.onOrderChange}
            query={this.state.searchQuery}
            superhosts={this.props.superhosts}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    superhosts: state.superhosts.superhosts.values,
    count: state.superhosts.superhosts.count,
    total_pages: state.superhosts.superhosts.total_pages,
    page: state.superhosts.superhosts.page,
    query: state.superhosts.superhosts.query
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    deleteSuperhosts: (user_ids) => dispatch(showDeleteSuperhostsConfirmationModal(user_ids)),
    getSuperhosts: (query, page) => dispatch(getSuperhosts(query, page))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Superhosts);


// WEBPACK FOOTER //
// ./src/containers/Admin/Superhosts/Superhosts.jsx